import { useTranslation } from 'react-i18next';
import FullscreenContainer from './FullscreenContainer';
import { splashImage } from '../ui/seasonalAssets';

const BOT_USERNAME = 'web3islands_bot';
const BACKGROUND = splashImage();

/** startapp param carried over from the web link (?startapp=plot_12), if any. */
function startParam(): string {
  try {
    const q = new URLSearchParams(window.location.search);
    return q.get('startapp') ?? q.get('tgWebAppStartParam') ?? '';
  } catch {
    return '';
  }
}

/**
 * Shown instead of the game when it is opened outside Telegram (it used to fail
 * with "server under maintenance"): asks to open it in the Telegram app.
 */
export default function OpenInTelegramScreen() {
  const { t } = useTranslation();
  const param = startParam();
  const webLink = `https://t.me/${BOT_USERNAME}?startapp${param ? `=${encodeURIComponent(param)}` : ''}`;
  const appLink = `tg://resolve?domain=${BOT_USERNAME}&startapp${param ? `=${encodeURIComponent(param)}` : ''}`;

  // Straight into the Telegram app; if it is not installed the page stays
  // visible, and we fall back to t.me (which offers to install / open the web app).
  const openTelegram = () => {
    const fallback = window.setTimeout(() => {
      if (document.visibilityState === 'visible') window.location.href = webLink;
    }, 1500);
    document.addEventListener('visibilitychange', () => window.clearTimeout(fallback), { once: true });
    window.location.href = appLink;
  };

  return (
    <FullscreenContainer className="loto-font">
      <div className="relative h-full w-full overflow-hidden bg-black">
        <img src={BACKGROUND} alt="" className="absolute inset-0 z-0 h-full w-full object-cover object-top" />
        <div className="relative z-[1] flex h-full w-full flex-col items-center justify-end gap-lg p-2xl pb-[max(32px,env(safe-area-inset-bottom))]">
          <div className="flex w-full max-w-[340px] flex-col items-center gap-lg rounded-xl bg-black/70 p-2xl text-center text-white backdrop-blur-sm">
            <h1 className="m-0 text-[20px] leading-[26px] font-extrabold">{t("Web3 Islands lives in Telegram")}</h1>
            <p className="m-0 text-[14px] leading-[20px] opacity-85">
              {t("Open the game in the Telegram app to build your house, tap pearls and meet your neighbours.")}
            </p>
            <button
              type="button"
              onClick={openTelegram}
              className="w-full cursor-pointer rounded-pill border-none bg-[image:var(--gradient-action-primary)] px-2xl py-lg [font-family:'Rubik_One',sans-serif] text-[16px] leading-[24px] text-white shadow-action-raised"
            >
              {t("Open in Telegram")}
            </button>
            <a href={webLink} className="text-[13px] text-white/60 underline">
              t.me/{BOT_USERNAME}
            </a>
          </div>
        </div>
      </div>
    </FullscreenContainer>
  );
}
